/* eslint-disable indent */
import React, { useRef } from "react";
import PropTypes from "prop-types";
import ReactHTMLTableToExcel from "react-html-table-to-excel";

import {
  isAdmin,
  isSuperAdmin,
  locationRender,
  renderAccessLocation2,
  renderLocationFunction
} from "../../constant/helper/helper";
import isEmpty from "../../validation/isEmpty";
import Card from "../../component/card/Card";
import SelectInput2 from "../../component/input/SelectInput2";
import Button from "../../component/button/Button";
import SpinnerButton from "../../component/spinner/SpinnerButton";

const UserLocationList = ({
  currentUser,
  onDeleteFace,
  allLocations,
  userAddLoading,
  newLocationToUser,
  usersLocationAndFace,
  addNewLocationToUser,
  setNewLocationToUser
}) => {
  const componentRef = useRef();

  const showUserList = (allLocationAndFace) => {
    if (!isEmpty(allLocationAndFace)) {
      return allLocationAndFace.map(
        (singleUser, faceLocationIndex) => {
          return (
            <tr
              key={faceLocationIndex}
              style={{ fontSize: "12px" }}
              className={
                !singleUser?.isActive ? "bg-danger text-white" : null
              }
            >
              <td className="">{faceLocationIndex + 1}</td>
              <td className="">{singleUser.workerId}</td>
              <td className="">{singleUser?.locationName}</td>
              <td className="">{singleUser?.locationCode}</td>
              <td className="">
                {singleUser?.externalIds.map(
                  (external, externalIndex) => (
                    <strong key={externalIndex}>
                      E-Ids {externalIndex + 1},
                    </strong>
                  )
                )}
              </td>
              <td className="">
                {singleUser?.faceIds.map((face, faceIndex) => (
                  <strong key={faceIndex}>
                    F-Ids {faceIndex + 1},
                  </strong>
                ))}
              </td>
              <td className="">
                {singleUser?.imageIds.map((image, imageIndex) => (
                  <strong key={imageIndex}>
                    {" "}
                    I-Ids {imageIndex + 1},
                  </strong>
                ))}
              </td>
              {/* <td className="">
                {singleUser?.registerFaceImages.map(
                  (image, imageIndex) => (
                    <strong key={imageIndex}>
                      <a
                        href={image}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ fontSize: 10 }}
                      >
                        {" "}
                        image No {imageIndex + 1},
                      </a>
                    </strong>
                  )
                )}
              </td> */}
              <td className="">
                {singleUser?.awsImageLinks.map(
                  (image, awsImageIndex) => (
                    <strong key={awsImageIndex}>
                      <a
                        href={image}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ fontSize: 10 }}
                      >
                        {" "}
                        Image No {awsImageIndex + 1},
                      </a>
                    </strong>
                  )
                )}
              </td>
              {isSuperAdmin(currentUser) || isAdmin(currentUser) ? (
                <td className="text-center">
                  <button
                    data-toggle="modal"
                    data-target={`#${faceLocationIndex}`}
                  >
                    Delete
                  </button>
                  <div
                    className="modal fade"
                    id={faceLocationIndex}
                    tabIndex="-1"
                    role="dialog"
                    aria-labelledby="fullWidthModalLabel"
                    aria-hidden="true"
                  >
                    <div className="modal-dialog">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h4
                            className="modal-title"
                            id="fullWidthModalLabel"
                          >
                            Delete Register Image of{" "}
                            {singleUser.workerId}
                          </h4>

                          <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-hidden="true"
                          >
                            ×
                          </button>
                        </div>

                        <div className="modal-body">
                          <h4>
                            Are you Sure? you want to delete register
                            Image of {singleUser.workerId}
                          </h4>
                        </div>
                        <div className="modal-footer">
                          <Button
                            type="button"
                            title="Close"
                            data-dismiss="modal"
                            className="btn btn-light"
                            isBackgroundColor={false}
                          />
                          <Button
                            title={`Delete For ${singleUser?.locationName}`}
                            className="btn btn-danger"
                            isBackgroundColor={false}
                            icon="mdi mdi-minus-circle-outline mr-2"
                            type="button"
                            onClick={(e) =>
                              onDeleteFace(e, singleUser)
                            }
                          />
                          {/* <Button
                            type="button"
                            title="Delete All"
                            className="btn btn-danger"
                            isBackgroundColor={false}
                            icon="mdi mdi-minus-circle-outline mr-2"
                          /> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              ) : null}
            </tr>
          );
        }
      );
    } else {
      return (
        <tr>
          <td>
            <span className=""> No Record Found</span>
          </td>
        </tr>
      );
    }
  };

  return (
    <Card className="mt-2">
      <div className="row">
        <div className="col-lg-3 col-md-3 col-sm-12">
          <SelectInput2
            data-tip
            isLabeled={true}
            onChange={(e) => setNewLocationToUser(e.target.value)}
            name="newLocationToUser"
            label="Select Location"
            data-for="newLocationToUser"
            value={newLocationToUser}
            placeholder="Select Location"
            icon="mdi mdi-map-marker-radius"
          >
            {isSuperAdmin(currentUser)
              ? renderLocationFunction(allLocations)
              : renderAccessLocation2(
                  locationRender(currentUser, false)
                )}
          </SelectInput2>
        </div>
        <div className="col-xl-3 col-lg-3 col-md-2 col-sm-2">
          {userAddLoading ? (
            <SpinnerButton />
          ) : (
            <Button
              data-tip
              type="button"
              title="Submit"
              data-for="addNew"
              isBackgroundColor={false}
              onClick={addNewLocationToUser}
              icon="mdi mdi-database-plus mr-2"
              className="btn text-white btn-block btn-dark float-right"
            />
          )}
        </div>
      </div>
      <div
        className="table-responsive"
        ref={componentRef}
        style={{ height: "200px", overflow: "auto" }}
      >
        <table
          className="table table-bordered table-centered mb-0 table-hover w-100 dt-responsive nowrap"
          id="products-datatable"
        >
          <thead className="thead-light">
            <tr>
              <th style={{ width: "20px" }}>#</th>
              <th>E-code</th>
              <th className="">Location Name</th>
              <th className="">Location Code</th>
              <th className="">External Ids</th>
              <th className="">Face Ids</th>
              <th className="">Image Ids</th>
              {/* <th className="">Register Images</th> */}
              <th className="">Register Aws Images</th>
              {isSuperAdmin(currentUser) || isAdmin(currentUser) ? (
                <th className="text-center">Actions</th>
              ) : null}
            </tr>
          </thead>
          <tbody>{showUserList(usersLocationAndFace)}</tbody>
        </table>
      </div>
      <div className="row mt-3">
        <div className="col-sm-1"></div>
        <div className="col-sm-4"></div>
        <div className="col-2">
          <ReactHTMLTableToExcel
            data-tip
            sheet="Sheet"
            buttonText="Export"
            data-for="exportToExcel"
            table="products-datatable"
            filename="User On Location List"
            className="btn btn-orange-dev btn-block text-white"
          />
        </div>
        <div className="col-sm-1"></div>
        <div className="col-sm-4"></div>
      </div>
    </Card>
  );
};

UserLocationList.propTypes = {
  onDeleteFace: PropTypes.func,
  allLocations: PropTypes.array,
  currentUser: PropTypes.object,
  userAddLoading: PropTypes.bool,
  newLocationToUser: PropTypes.string,
  addNewLocationToUser: PropTypes.func,
  setNewLocationToUser: PropTypes.func,
  usersLocationAndFace: PropTypes.array
};

export default UserLocationList;
